"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var QuantitySelector = function QuantitySelector(_ref) {
  var quantity = _ref.quantity,
      onQuantityChange = _ref.onQuantityChange,
      checkoutDisabled = _ref.checkoutDisabled;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button.Group, {
    inverted: true
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    disabled: quantity === 1 || checkoutDisabled,
    onClick: function onClick() {
      return onQuantityChange(-1);
    },
    icon: {
      name: 'minus',
      color: 'black'
    }
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    disabled: checkoutDisabled
  }, quantity), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    disabled: checkoutDisabled,
    onClick: function onClick() {
      return onQuantityChange(1);
    },
    icon: {
      name: 'plus',
      color: 'black'
    }
  }));
};

var _default = QuantitySelector;
exports["default"] = _default;